import { lensPath, view } from 'ramda';
import heic2any from 'heic2any';

export const generateId = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
}

export const poll = async ({ fn, validate, interval, maxAttempts, errorMessage }) => {
  let attempts = 0;

  const executePoll = async (resolve, reject) => {
    const result = await fn();
    attempts++;

    if (validate(result)) {
      return resolve(result);
    } else if (maxAttempts && attempts === maxAttempts) {
      return reject(new Error(errorMessage || 'Exceeded max attempts'));
    } else {
      setTimeout(executePoll, interval, resolve, reject);
    }
  };

  return new Promise(executePoll);
};

const convertHeicImageToJpeg = blob => heic2any({
  blob,
  toType: 'image/jpeg',
  quality: 0.5,
});

export const prepareForValidation = async (file) => {
  let preparedFile = file;

  // convert to jpg
  if (['image/heic', 'image/heif'].includes(file.type)) {
    const fileName = file.name.replace(/(\.hei.)/gi, '.jpg');
    preparedFile = new File([await convertHeicImageToJpeg(file)], fileName);
  }

  return preparedFile;
};
